var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "item",
      class: { editMode: _vm.editMode },
      style: _vm.style,
    },
    [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm._t("default"),
          _c("transition", { attrs: { name: "mask-fade" } }, [
            _vm.editMode
              ? _c("div", {
                  staticClass: "mask",
                  on: {
                    mousedown: function ($event) {
                      return _vm.onDragStart($event)
                    },
                  },
                })
              : _vm._e(),
          ]),
          _c("transition", { attrs: { name: "border-vertical" } }, [
            _vm.editMode
              ? _c(
                  "div",
                  {
                    staticClass: "border border-top",
                    on: {
                      mousedown: function ($event) {
                        return _vm.onScaleTopStart()
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "bars" } })],
                  1
                )
              : _vm._e(),
          ]),
          _c("transition", { attrs: { name: "border-horizontal" } }, [
            _vm.editMode
              ? _c(
                  "div",
                  {
                    staticClass: "border border-right",
                    on: {
                      mousedown: function ($event) {
                        return _vm.onScaleRightStart()
                      },
                    },
                  },
                  [
                    _c("w-fa", {
                      attrs: { transform: "rotate-90", icon: "bars" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("transition", { attrs: { name: "border-horizontal" } }, [
            _vm.editMode
              ? _c(
                  "div",
                  {
                    staticClass: "border border-left",
                    on: {
                      mousedown: function ($event) {
                        return _vm.onScaleLeftStart()
                      },
                    },
                  },
                  [
                    _c("w-fa", {
                      attrs: { transform: "rotate-90", icon: "bars" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("transition", { attrs: { name: "border-vertical" } }, [
            _vm.editMode
              ? _c(
                  "div",
                  {
                    staticClass: "border border-bottom",
                    on: {
                      mousedown: function ($event) {
                        return _vm.onScaleBottomStart()
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "bars" } })],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "buttons-container" },
            [_vm._t("buttons-container")],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }